// fetchBaseQuery reports a 404 with no JSON body as PARSING_ERROR, with the code in originalStatus.
export const isNotFoundError = (error: unknown): boolean => {
  const candidate = error as { status?: number | string; originalStatus?: number } | null;
  return candidate?.status === 404 || candidate?.originalStatus === 404;
};
